module.exports = __webpack_public_path__ + "media/images/incomm-logo-115dc22f.png";